/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.1.24",
    versionName: "0.2.0-nightly.2026.1.24",
    versionChannel: "nightly",
    buildDate: "2026-01-24T00:07:58.631Z",
    commitHash: "31ab4c5d8ad05a61a0cdf7c10657b546b64f95e4",
};
